module.exports = __webpack_public_path__ + "img/digitalIdentity19.47e093db.png";